import i18n from "@/plugins/vue-i18n";

import DealershipApplications from "@/views/settings/dealership-applications/index";
import DealershipApplicationsList from "@/views/settings/dealership-applications/index/tabs/ApplicationsTab.vue";
import DealershipApplicationsDetails from "@/views/settings/dealership-applications/details";

const dealershipApplications = [
  {
    path: "settings/new-applications",
    redirect: (to) => ({
      name: "DealershipApplications",
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: "settings/new-applications/:id/details",
    redirect: (to) => ({
      name: "DealershipApplicationsDetails",
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: "settings/dealership-applications",
    component: DealershipApplications,
    children: [
      {
        path: "",
        name: "DealershipApplications",
        component: DealershipApplicationsList,
        meta: {
          title: i18n.t("title.dealershipApplications._"),
        },
      },
    ],
  },
  {
    path: "settings/dealership-applications/:id/details",
    name: "DealershipApplicationsDetails",
    component: DealershipApplicationsDetails,
    meta: {
      title: i18n.t("title.dealershipApplications.details"),
    },
  },
];

export default dealershipApplications;
